import { Socket, Manager } from "socket.io-client";

export interface NotificationSocketDataSource {
	connectSocket(): Promise<void>;
	disconnectSocket(): Promise<void>;
	onPurchaseMessageNotification(callback: (data: number) => void): void;
}

export class NotificationSocketDataSourceImpl implements NotificationSocketDataSource {
	private socket: Socket | null = null;
	private onPurchaseMessageNotificationCallback: ((data: number) => void) | null = null;

	async connectSocket(): Promise<void> {
		const token = localStorage.getItem("userToken");
		if (!token) {
			throw new Error("No se encontró el token");
		}

		const manager = new Manager(`${process.env.REACT_APP_UNJABBED}/socket.io/socket.io.js`, {
			transports: ["websocket"],
			extraHeaders: {
				authorization: `Bearer ${token}`,
			},
		});

		this.socket = manager.socket("/message-token", { auth: { token } });
		this.socket.connect();

		this.socket.on("purchase_message_notification", (data) => {
			if (this.onPurchaseMessageNotificationCallback) {
				this.onPurchaseMessageNotificationCallback(data);
			}
		});

		this.socket.on("error", (data) => {
			console.error("Error en el socket:", data);
		});
	}

	disconnectSocket(): Promise<void> {
		return new Promise((resolve) => {
			if (this.socket) {
				this.socket.disconnect();
				this.socket = null;
			}
			resolve();
		});
	}
	onPurchaseMessageNotification(callback: (data: number) => void): void {
		this.onPurchaseMessageNotificationCallback = callback;
	}
}
